<template>
  <v-app>
    <v-container fluid>
      <v-row>
        <!-- LEFT SIDE -->
        <v-col md="3" cols="12">
          <v-expansion-panels v-model="panel">
            <v-expansion-panel>
              <v-expansion-panel-title
                color="blue-grey-lighten-4"
                class="panel-header"
              >
                Price Inquiry Info
              </v-expansion-panel-title>

              <v-expansion-panel-text class="pa-3">
                <v-row>

                  <!-- Customer -->
                  <v-col cols="12" class="d-none">
                    <v-autocomplete
                      label="Customer"
                      v-model="customer_id"
                      :items="getCustomerList"
                      item-title="company_name"
                      item-value="id"
                      density="compact"
                      variant="outlined"
                      clearable
                      hide-details
                      :error-messages="errors.customer_id"
                    />
                  </v-col>

                  <!-- Lead -->
                  <v-col cols="12">
                    <v-autocomplete
                      label="Lead *"
                      v-model="lead_id"
                      :items="getLeadList"
                      :item-title="(item) => `${item.code}-${item.company_name}` ?? 'N/A'"
                      item-value="id"
                      density="compact"
                      variant="outlined"
                      clearable
                      hide-details
                      :error-messages="errors.lead_id"
                    />
                  </v-col>

                  <!-- Representative -->
                  <v-col cols="12" class="d-none">
                    <v-autocomplete
                      label="Representative"
                      v-model="representative_id"
                      :items="getRepresentativeList"
                      item-title="name"
                      item-value="id"
                      density="compact"
                      variant="outlined"
                      clearable
                      hide-details
                      :error-messages="errors.representative_id"
                    />
                  </v-col>

                  <!-- Final Price -->
                  <v-col cols="12">
                    <v-text-field
                      label="Final Price *"
                      v-model="final_price"
                      type="number"
                      density="compact"
                      variant="outlined"
                      clearable
                      hide-details
                      :error-messages="errors.final_price"
                    />
                  </v-col>

                  <!-- Discussion -->
                  <v-col cols="12">
                    <v-textarea
                      label="Discussion"
                      v-model="discussion"
                      density="compact"
                      variant="outlined"
                      rows="2"
                      clearable
                      hide-details
                      :error-messages="errors.discussion"
                    />
                  </v-col>

                  <!-- Clarification -->
                  <v-col cols="12">
                    <v-textarea
                      label="Clarification"
                      v-model="clarification"
                      density="compact"
                      variant="outlined"
                      rows="2"
                      clearable
                      hide-details
                      :error-messages="errors.clarification"
                    />
                  </v-col>

                </v-row>
              </v-expansion-panel-text>
            </v-expansion-panel>
          </v-expansion-panels>
        </v-col>

        <!-- RIGHT SIDE -->
        <v-col md="9" cols="12">
          <v-expansion-panels v-model="panel1">
            <v-expansion-panel>

              <v-expansion-panel-title
                color="blue-grey-lighten-4"
                class="panel-header"
              >
                Price Inquiry Details
              </v-expansion-panel-title>

              <v-expansion-panel-text class="pa-3">
                <v-row>

                  <v-col cols="12">
                        <div style="overflow-x: auto; width: 100%; padding: 10px;">
                        <v-table
                            density="compact"
                            fixed-header
                            class="table-dotted-border-bottom"
                            style=" overflow-y: auto; min-width: 1170px;">

                            <thead>
                                <tr>
                                <th style="width:250px; text-align: center;">Product</th>
                                <th style="width:120px; text-align: center;">Net Weight</th>
                                <th style="width:120px; text-align: center;">Gross Weight</th>
                                <th style="width:120px; text-align: center;">CBM</th>
                                <th style="width:120px; text-align: center;">Remarks</th>
                                <th style="width:120px; text-align: center;">Attachment</th>
                                <th style="width:120px; text-align: center;">Packing List</th>
                                <th style="width:100px; text-align: center;">Action</th>
                                </tr>
                            </thead>

                            <tbody>
                                <tr
                                v-for="(item, index) in details"
                                :key="index"
                                >
                                <!-- Product -->
                                <td>
                                    <v-autocomplete
                                    v-model="item.product_id"
                                    :items="getProductList"
                                    :item-title="(item) => `${item.product.code}-${item.product.name}` ?? 'N/A'"
                                    item-value="id"
                                    density="compact"
                                    variant="outlined"
                                    clearable
                                    hide-details
                                    :error-messages="errors[`details_${index}_product_id`]"
                                    />
                                </td>

                                <!-- Net Weight -->
                                <td>
                                    <v-text-field
                                    v-model="item.net_weight"
                                    type="number"
                                    density="compact"
                                    variant="outlined"
                                    hide-details
                                    :error-messages="errors[`details_${index}_net_weight`]"
                                    />
                                </td>

                                <!-- Gross Weight -->
                                <td>
                                    <v-text-field
                                    v-model="item.gross_weight"
                                    type="number"
                                    density="compact"
                                    variant="outlined"
                                    hide-details
                                    :error-messages="errors[`details_${index}_gross_weight`]"
                                    />
                                </td>

                                <!-- CBM -->
                                <td>
                                    <v-text-field
                                    v-model="item.cbm"
                                    type="number"
                                    density="compact"
                                    variant="outlined"
                                    hide-details
                                    :error-messages="errors[`details_${index}_cbm`]"
                                    />
                                </td>

                                <!-- Remarks -->
                                <td>
                                    <v-textarea
                                    v-model="item.remarks"
                                    density="compact"
                                    variant="outlined"
                                    rows="1"
                                    auto-grow
                                    hide-details
                                    :error-messages="errors[`details_${index}_remarks`]"
                                    />
                                </td>

                                <!-- Attachment -->
                                <td>
                                    <v-file-input
                                    v-model="item.attachment"
                                    density="compact"
                                    variant="outlined"
                                    prepend-icon=""
                                    hide-details
                                    clearable
                                    show-size
                                    />
                                </td>

                                <!-- Packing -->
                                <td>
                                    <v-file-input
                                    v-model="item.attachment_packing_list"
                                    density="compact"
                                    variant="outlined"
                                    prepend-icon=""
                                    hide-details
                                    clearable
                                    show-size
                                    />
                                </td>

                                <!-- Action -->
                                <td>
                                    <v-btn
                                    v-if="(index != details.length - 1) || (details.length > 1)"
                                    icon
                                    variant="tonal"
                                    size="small"
                                    color="primary"
                                    class="pa-1 breakdown-input"
                                    @click="removeItem(index)"
                                    >
                                    <v-icon color="red">
                                        mdi-close
                                    </v-icon>
                                    </v-btn>

                                    <v-btn
                                    v-if="index == details.length - 1"
                                    variant="tonal"
                                    icon
                                    size="small"
                                    color="primary"
                                    class="breakdown-input"
                                    @click="addItem"
                                    >
                                    <v-icon color="blue">
                                        mdi-plus
                                    </v-icon>
                                    </v-btn>
                                </td>

                                </tr>
                            </tbody>
                            </v-table>
                        </div>
                  </v-col>

                  <!-- BUTTON -->
                  <v-col cols="12" class="d-flex justify-end mt-4">

                    <v-btn
                      class="bg-grey-darken-1 me-2"
                      variant="flat"
                      :loading="loading"
                      @click="submitData(0)"
                    >
                      Draft
                    </v-btn>

                    <v-btn
                      class="bg-primary"
                      variant="flat"
                      :loading="loading"
                      @click="submitData(1)"
                    >
                      {{ isEdit ? "Update" : "Save" }}
                    </v-btn>

                  </v-col>

                </v-row>
              </v-expansion-panel-text>

            </v-expansion-panel>
          </v-expansion-panels>
        </v-col>

      </v-row>
    </v-container>
  </v-app>
</template>

<script setup>
import { ref, computed, onMounted } from "vue";
import { useStore } from "vuex";
import { useRouter, useRoute } from "vue-router";
import { toast } from "vue3-toastify";

const store = useStore();
const router = useRouter();
const route = useRoute();

const panel = ref([0]);
const panel1 = ref([0]);

const loading = ref(false);
const isEdit = ref(false);

const priceInquiryId = ref(null);

/* ================= FORM ================= */

const customer_id = ref(null);
const lead_id = ref(null);
const representative_id = ref(null);

const final_price = ref(null);

const discussion = ref("");
const clarification = ref("");

const details = ref([]);

/* ================= ERROR ================= */

const errors = ref({});

/* ================= GETTERS ================= */

const getCustomerList = computed(() => {
  return store.getters.getCustomerList || [];
});

const getLeadList = computed(() => {
  return store.getters.getSalesLeads || [];
});

const getRepresentativeList = computed(() => {
  return store.getters.getEmployeeList || [];
});

const getProductList = computed(() => {
  return store.getters.getProductMapList || [];
});

/* ================= METHODS ================= */

const addItem = () => {

  details.value.push({

    product_id: null,

    net_weight: null,
    gross_weight: null,
    cbm: null,

    remarks: "",

    attachment: null,
    attachment_packing_list: null,

  });

};

const removeItem = (index) => {

  details.value.splice(index, 1);

};

const validate = () => {

  errors.value = {};

  if (!final_price.value) {
    errors.value.final_price = ["Required"];
  }

  if(!lead_id.value){
    errors.value.lead_id = ["Required"];
  }

  if (!details.value.length) {
    errors.value.details = ["At least one item required"];
  }

  details.value.forEach((item, index) => {

    if (!item.product_id) {
      errors.value[`details_${index}_product_id`] = ["Required"];
    }

  });

  return Object.keys(errors.value).length === 0;

};

const submitData = async (statusValue) => {

  if (!validate()) return;

  loading.value = true;

  try {

    const formData = new FormData();

    if (isEdit.value) {
      formData.append(
        "price_inquiry_master_id",
        priceInquiryId.value
      );
    }

    formData.append("customer_id", customer_id.value || "");
    formData.append("lead_id", lead_id.value || "");
    formData.append("representative_id", representative_id.value || "");

    formData.append("discussion", discussion.value || "");
    formData.append("clarification", clarification.value || "");

    formData.append("final_price", final_price.value || 0);

    formData.append("status", statusValue);

    details.value.forEach((item, index) => {

      formData.append(
        `details[${index}][product_id]`,
        item.product_id || ""
      );

      formData.append(
        `details[${index}][net_weight]`,
        item.net_weight || 0
      );

      formData.append(
        `details[${index}][gross_weight]`,
        item.gross_weight || 0
      );

      formData.append(
        `details[${index}][cbm]`,
        item.cbm || 0
      );

      formData.append(
        `details[${index}][remarks]`,
        item.remarks || ""
      );

      if (item.attachment) {

        formData.append(
          `details[${index}][attachment]`,
          item.attachment
        );

      }

      if (item.attachment_packing_list) {

        formData.append(
          `details[${index}][attachment_packing_list]`,
          item.attachment_packing_list
        );

      }

    });

    await store.dispatch(
      "saveUpdatePriceInquiry",
      formData
    );

    toast.success(
      isEdit.value
        ? "Price inquiry updated successfully"
        : "Price inquiry saved successfully"
    );

    router.push({
      name: "price-inquery-records"
    });

  } catch (error) {

    toast.error(
      error.response?.data?.message ||
      "Something went wrong!"
    );

  } finally {

    loading.value = false;

  }

};

const loadData = async () => {

  await store.dispatch("getCustomerList");
  await store.dispatch("getSalesLeads");
  await store.dispatch("getEmployeeList");
  await store.dispatch("getProductMapList");

};

const loadPriceInquiry = async (id) => {

  try {

    const res = await store.dispatch(
      "getPriceInquiryById",
      id
    );

    const data = res.data;

    customer_id.value = data.customer_id;
    lead_id.value = data.lead_id;
    representative_id.value = data.representative_id;

    final_price.value = data.final_price;

    discussion.value = data.discussion;
    clarification.value = data.clarification;

    details.value = data.details.map((item) => ({

      product_id: item.product_id,

      net_weight: item.net_weight,
      gross_weight: item.gross_weight,
      cbm: item.cbm,

      remarks: item.remarks,

      attachment: null,
      attachment_packing_list: null,

      old_attachment: item.attachment,
      old_attachment_packing_list:
        item.attachment_packing_list,

    }));

  } catch (error) {

    toast.error("Failed to load data");

  }

};

onMounted(async () => {

  addItem();

  loading.value = true;

  await loadData();

  if (route.params.id) {

    isEdit.value = true;

    priceInquiryId.value = route.params.id;

    await loadPriceInquiry(
      priceInquiryId.value
    );

  }

  loading.value = false;

});
</script>